/* eslint-disable react/prop-types, react/jsx-first-prop-new-line, react/jsx-closing-bracket-location */
import React from 'react';
import classnames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import { TranscodedImage, TranscodedImageSizes } from 'es6/components/common/transcoded-image';
import MouseoverDictionary from 'iknow-mouseover-dictionary/react';
import SoundPlayer, { SOUND_PLAYER_SENTENCE } from 'es6/components/common/sound-player';
import {
  ITEM_CUE_WORD_COLOR,
} from 'es6/core/styles/colors';


export default function Sentence({ sentence }) {
  const text = tagCueWords(sentence.getText());
  const transliteration = tagCueWords(sentence.getTransliteration());
  const translation = tagCueWords(sentence.getTranslation());
  const image = sentence.getImage();
  const sound = sentence.sound;

  return (
    <div className={css(styles.sentence)}>
      <div className={classnames(css(styles.texts), { [css(styles.textsNoImage)]: !image })}>
        <p className={css(styles.original)}>
          <MouseoverDictionary html={text} />
          {' '}
          <SoundPlayer source={sound} variant={SOUND_PLAYER_SENTENCE} />
        </p>
        <p className={css(styles.transliteration)}
          dangerouslySetInnerHTML={{ __html: transliteration }} />
        <p className={css(styles.translation)}
          dangerouslySetInnerHTML={{ __html: translation }} />
      </div>
      {image ? <div className={css(styles.image)}>
        <TranscodedImage src={image} size={TranscodedImageSizes.MEDIUM} />
      </div> : null}
    </div>
  );
}

const styles = StyleSheet.create({
  sentence: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
    marginBottom: '15px',
  },
  image: {
    marginLeft: '15px',
    flex: '0 0 auto',
  },
  texts: {
    fontSize: '16px',
    flex: '1 1 auto',
  },
  textsNoImage: {
    paddingRight: '60px',
  },
  cue: {
    color: ITEM_CUE_WORD_COLOR,
    fontWeight: 'inherit',
  },
  original: {
    lineHeight: '1.5em',
  },
  transliteration: {
    fontSize: '14px',
    lineHeight: '1.5em',
  },
  translation: {
    marginTop: '10px',
    marginBottom: '20px',
    lineHeight: '1.5em',
  },
});

function tagCueWords(html) {
  return (html || '').replace(/<b>/g, `<b class=${css(styles.cue)}>`);
}
